module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_ZoomIn_16"],"path":[{"$":{"d":"M10,8H8v2H6V8H4V6H6V4H8V6h2Zm2.66,3.11a7,7,0,1,0-1.56,1.56L14.42,16,16,14.42ZM7,12.5A5.5,5.5,0,1,1,12.5,7,5.51,5.51,0,0,1,7,12.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_ZoomIn_16.svg
// module id = Ld/1
// module chunks = 1